import { Suspense, useEffect, lazy } from 'react';
import { useLocation } from 'react-router';
const Header = lazy(() => import('@/components/Header/Header'));
const Footer = lazy(() => import('@/components/Footer/Footer'));
import Loading from '@/components/Loading/Loading';

function Layout({ page, section, children }) {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return (
        <>
            <Suspense fallback={<Loading />}>
                <div className="main-background">
                    <Header page={page} section={section} />

                    <main className="main-content" id="main">
                        {children}
                    </main>
                </div>

                <Footer />
            </Suspense>
        </>
    );
}

export default Layout;
